var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContracts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6667 8H7.33337V9H2.6667V8ZM2.6667 6H9.33337V7H2.6667V6ZM2.6667 4H9.33337V5H2.6667V4ZM10.6667 1.3H7.88004C7.60004 0.546 6.8667 0 6.00004 0C5.13337 0 4.40004 0.546 4.12004 1.3H1.33337C1.24004 1.3 1.15337 1.3065 1.0667 1.326C0.806703 1.378 0.57337 1.508 0.39337 1.6835C0.27337 1.8005 0.17337 1.9435 0.106703 2.0995C0.0400366 2.249 3.65647e-05 2.418 3.65647e-05 2.6L1.81496e-05 10.7025C1.81496e-05 10.878 -0.0266481 11.0705 0.0400185 11.2265C0.106685 11.3825 0.206685 11.519 0.326685 11.6425C0.506685 11.818 0.740018 11.948 1.00002 12C1.08669 12.013 1.4067 12 1.50004 12L10.6667 11.9928C11.4 11.9928 12 11.4078 12 10.6928V2.6C12 1.885 11.4 1.3 10.6667 1.3ZM6.00004 0.525C6.27337 0.525 6.50004 0.746 6.50004 1.0125C6.50004 1.279 6.27337 1.5 6.00004 1.5C5.7267 1.5 5.50004 1.279 5.50004 1.0125C5.50004 0.746 5.7267 0.525 6.00004 0.525ZM11 11H1.00004V2H11V11Z",
    fill: "#3F3F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.23b7a8d1.svg";
export { ForwardRef as ReactComponent };